import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, ExternalLink } from 'lucide-react';
// NOTE: Replace these with your client's actual Google reviews.
// Copy the reviewer name, star rating, date, and text directly from their Google Business Profile.
const reviews = [{
  name: 'Maria G.',
  initial: 'M',
  color: 'bg-blue-500',
  rating: 5,
  date: '2 weeks ago',
  text: "Jose and his team were absolutely amazing. They cleared out my late father's garage — years of clutter — in just one afternoon. Professional, respectful, and incredibly hard-working. Highly recommend!"
}, {
  name: 'David R.',
  initial: 'D',
  color: 'bg-green-600',
  rating: 5,
  date: '1 month ago',
  text: 'Called Jose on a Saturday morning, he was at my house by noon. Hauled away an old hot tub plus a ton of yard debris. Fair price, no hassle. Will definitely call again.'
}, {
  name: 'Jennifer L.',
  initial: 'J',
  color: 'bg-red-500',
  rating: 5,
  date: '1 month ago',
  text: "As a property manager, I've used a lot of junk removal services. Jose's is the best in Monterey, hands down. Fast quotes, shows up on time, leaves the unit spotless. My go-to crew."
}, {
  name: 'Carlos M.',
  initial: 'C',
  color: 'bg-purple-600',
  rating: 5,
  date: '2 months ago',
  text: 'We had a small demo job plus concrete removal. Jose handled it all — saved us from hiring two different companies. Honest pricing and the crew worked their tails off. 10/10.'
}, {
  name: 'Susan T.',
  initial: 'S',
  color: 'bg-yellow-600',
  rating: 5,
  date: '3 months ago',
  text: "Cleaned out my mom's estate after she passed. Jose was so kind and patient with us. Took care of everything — furniture, appliances, even an old piano. Truly a blessing."
}, {
  name: 'Mike P.',
  initial: 'M',
  color: 'bg-indigo-600',
  rating: 5,
  date: '4 months ago',
  text: "Contractor here. Jose's crew is my first call for site cleanups. Reliable, no excuses, fair pricing. Saves me a ton of time between phases. Top-notch operation."
}];
function StarRow({
  count = 5
}: {
  count?: number;
}) {
  return <div className="flex items-center gap-0.5" data-id="element-272" data-mp="3pgxt1mrs7olp">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} size={18} className={i < count ? 'fill-[#FBBC04] text-[#FBBC04]' : 'text-gray-300'} data-id="element-273" data-mp="3kimgv5e0l20b" data-mpi={i} />)}
    </div>;
}
// Google "G" logo as inline SVG to avoid asset hosting
function GoogleLogo({
  size = 28
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" data-id="element-274" data-mp="c188j8or6lp3">
      <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12 s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20 s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" data-id="element-275" data-mp="72ohitvayjpv" />
      <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039 l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" data-id="element-276" data-mp="2hne2h7vzyk60" />
      <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36 c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" data-id="element-277" data-mp="2weej406wdkd8" />
      <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571 c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" data-id="element-278" data-mp="35ejq4986igqv" />
    </svg>;
}
export function GoogleReviews() {
  const averageRating = 5.0;
  const reviewCount = reviews.length;
  return <section id="reviews" className="py-24 bg-[#F9F9F9]" data-id="element-279" data-mp="1g27w2m99db6f">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-280" data-mp="1l09agtvqombk">
        {/* Heading */}
        <div className="text-center mb-12" data-id="element-281" data-mp="3bfjzo6n2p2yg">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-white border border-gray-200 px-4 py-2 rounded-full shadow-sm mb-6" data-id="element-282" data-mp="3bifzk0ihe1pj">
            <GoogleLogo size={20} data-id="element-283" data-mp="2rsm4ndkgz6h3" />
            <span className="text-sm font-bold tracking-wider uppercase text-gray-700" data-id="element-284" data-mp="2nr0tpxrhx29j">
              Google Verified Reviews
            </span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-6" data-id="element-285" data-mp="31k8m3rnei1sa">
            WHAT MONTEREY IS <span className="text-[#C8102E]" data-id="element-286" data-mp="jjxnzexmepdf">SAYING</span>
          </motion.h2>

          {/* Rating Summary */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex flex-col sm:flex-row items-center gap-3 sm:gap-5 bg-white px-6 py-4 rounded-xl border border-gray-200 shadow-sm" data-id="element-287" data-mp="od0ipqe4w4v7">
            <div className="flex items-center gap-3" data-id="element-288" data-mp="177z2r5le721a">
              <GoogleLogo size={32} data-id="element-289" data-mp="t9qyecm10yg3" />
              <div className="text-left" data-id="element-290" data-mp="tcwonv6e66de">
                <div className="font-bold text-[#1A1A1A] text-sm" data-id="element-291" data-mp="y8u4m0dqtapn">
                  Jose's Junk Removal
                </div>
                <div className="text-xs text-gray-500" data-id="element-292" data-mp="3dz6mgztv2921">
                  Google Business Profile
                </div>
              </div>
            </div>
            <div className="w-px h-10 bg-gray-200 hidden sm:block" data-id="element-293" data-mp="2yy9j9eh0ahm7"></div>
            <div className="flex items-center gap-3" data-id="element-294" data-mp="2yzkl38qw5fao">
              <span className="text-4xl font-bold text-[#1A1A1A]" data-id="element-295" data-mp="2uxfvcl3kd2tb">
                {averageRating.toFixed(1)}
              </span>
              <div data-id="element-296" data-mp="2q3bo00qdysrp">
                <StarRow count={5} data-id="element-297" data-mp="2l6ct3fywehsg" />
                <div className="text-xs text-gray-500 mt-0.5" data-id="element-298" data-mp="2l5a5pi0saxha">
                  Based on {reviewCount}+ reviews
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Reviews Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-299" data-mp="2b6ufdh9kzs8u">
          {reviews.map((review, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow relative flex flex-col" data-id="element-300" data-mp="278er7a1rkdtu" data-mpi={idx}>
              <Quote className="absolute top-5 right-5 text-gray-100" size={48} strokeWidth={1} data-id="element-301" data-mp="hqhlghejvv6o" />

              {/* Header: Avatar + Name */}
              <div className="flex items-center gap-3 mb-4 relative z-10" data-id="element-302" data-mp="3l76s03e4v4wc">
                <div className={`${review.color} text-white w-11 h-11 rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0`} data-id="element-303" data-mp="3q4q9dc64nxsi">
                  {review.initial}
                </div>
                <div className="min-w-0" data-id="element-304" data-mp="323im6h4w6q4">
                  <div className="font-bold text-[#1A1A1A] truncate" data-id="element-305" data-mp="1aedricq0ezg4">
                    {review.name}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-306" data-mp="1eeny9rlmltw1">{review.date}</div>
                </div>
              </div>

              {/* Stars + Google */}
              <div className="flex items-center justify-between mb-3" data-id="element-307" data-mp="20ewj3gt54b0j">
                <StarRow count={review.rating} data-id="element-308" data-mp="1vjzeqn6t2ptz" />
                <GoogleLogo size={16} data-id="element-309" data-mp="2a7kgodry2j0b" />
              </div>

              {/* Text */}
              <p className="text-gray-700 text-sm leading-relaxed relative z-10" data-id="element-310" data-mp="25gc3r7reofie">
                "{review.text}"
              </p>
            </motion.div>)}
        </div>

        {/* CTA to leave / read more reviews */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-311" data-mp="2e7m7tt01zu1c">
          <a href="https://www.google.com/search?q=Jose%27s+Junk+Removal+Monterey" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white border-2 border-gray-200 hover:border-[#C8102E] text-[#1A1A1A] px-6 py-3 rounded-full font-bold transition-colors shadow-sm" data-id="element-312" data-mp="yrdnbwybdpdv">
            <GoogleLogo size={20} data-id="element-313" data-mp="3ahbp8wy1zyxi" />
            <span data-id="element-314" data-mp="2vquq5k8w5l3s">Read All Reviews on Google</span>
            <ExternalLink size={16} className="text-gray-500" data-id="element-315" data-mp="2vq2vqcr15tf3" />
          </a>
        </motion.div>
      </div>
    </section>;
}